<template>
<div class="android-seat" v-if="config.android"></div>
</template>
<script lang="ts" setup>
import { config } from '@/store';
</script>
<style lang="less">
.android-seat {
    height: 3.2rem;
}
</style>